<template>
  <div v-if="vx_billInfo">
    <div class="row" v-if="!isMultiCars">
      <div class="col-md-4 col-sm-4">
        <span class="fontSize20 title-color">接單司機：{{ driverName }}</span>
      </div>
      <div class="col-md-4 col-sm-4">
        <span class="fontSize20 title-color">司機電話：{{ driverPhone }}</span>
      </div>
      <div class="col-md-4 col-sm-4">
        <span class="fontSize20 title-color">
          司機隊編/呼號：{{ driverCallNumber }}
        </span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="fontSize20 title-color">
          派單客服/行政人員：{{ clerkName }}
        </span>
      </div>
    </div>
    <!-- 修改乘客備註 -->
    <div v-if="isShow">
      <hr />
      <h4>修改乘客備註:</h4>
      <div class="col-md-7 col-sm-7">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          row="3"
          v-model="passengerNote"
          maxlength="300"
        />
      </div>
      <button class="btn-primary btn" @click="updatePassengerNote">更新</button>
    </div>
    <!-- 司機取消 -->
    <div v-if="!isMultiCars">
      <hr />
      <h4>司機取消:</h4>
      <div class="col-md-7 col-sm-7">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="司機取消訊息"
          row="3"
          v-model="driverCancelNote"
          maxlength="300"
        />
      </div>
      <button
        class="btn-primary btn"
        :class="{ 'btn-tooltip': isDisabled }"
        @click="driverCancel"
        :disabled="isDisabled"
      >
        司機取消
        <span class="tooltip-text">無司機接單</span>
      </button>
    </div>
    <!-- 乘客取消 -->
    <div v-if="isShow">
      <hr />
      <h4>乘客取消:</h4>
      <div class="col-md-7 col-sm-7">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="乘客取消訊息"
          row="3"
          v-model="passengerCancelNote"
          maxlength="300"
        />
      </div>
      <button class="btn-primary btn" @click="passengerCancel">乘客取消</button>
    </div>
  </div>
</template>

<script>
import {
  reqUpdatePassengerInfo,
  reqUpdatePassengerPosition,
  reqDriverCancel,
} from '@/api/reservation'
import { cookies } from '@/utils/cookies'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      passengerNote: '',
      driverCancelNote: '',
      passengerCancelNote: '',
    }
  },
  methods: {
    ...mapActions('reservation', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    initNote() {
      this.passengerNote = ''
      this.driverCancelNote = ''
      this.passengerCancelNote = ''
    },
    async updatePassengerNote() {
      const payload = {
        reservation_id: this.vx_billInfo.orderId,
        passenger_note: this.passengerNote,
      }
      try {
        const { result } = await reqUpdatePassengerInfo(payload)
        if (result) {
          Notification({
            title: '更新成功',
            type: 'success',
          })
          this.vx_fetchOrderDetail()
        } else {
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '更新失敗',
          type: 'error',
        })
        console.error(e)
      }
    },
    async driverCancel() {
      const position = cookies.get('Flag') === 'manager' ? 'manager' : 'service'
      const payload = {
        driverCancelNote: `${this.driverCancelNote}-${dayjs().format(
          'YYYY-MM-DD HH:mm:ss',
        )}`,
        reservationId: this.vx_billInfo.orderId,
      }
      try {
        await reqDriverCancel(position, payload)
        this.vx_fetchOrderDetail()
      } catch (e) {
        Notification({
          title: '更新失敗',
          message: e.error.message,
          type: 'error',
        })
        this.driverCancelNote = ''
        console.error(e)
      }
    },
    async passengerCancel() {
      const position = cookies.get('Flag') === 'manager' ? 'manager' : 'service'
      const payload = {
        reservationId: this.vx_billInfo.orderId,
        passengerCancelNote: `${this.passengerCancelNote}-${dayjs().format(
          'YYYY-MM-DD HH:mm:ss',
        )}`,
      }
      try {
        const { result } = await reqUpdatePassengerPosition(position, payload)
        if (result) {
          Notification({
            title: '更新成功',
            type: 'success',
          })
          this.vx_fetchOrderDetail()
        } else {
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '更新失敗',
          type: 'error',
        })
        console.error(e)
      }
    },
  },
  computed: {
    ...mapState('reservation', {
      vx_billInfo: (state) => state.modal.billInfo,
      vx_passengerInfo: (state) => state.modal.passengerInfo,
      vx_serviceInfo: (state) => state.modal.serviceInfo,
      vx_managerInfo: (state) => state.modal.managerInfo,
      vx_driverInfo: (state) => state.modal.driverInfo,
    }),
    isShow() {
      return this.vx_billInfo.result !== 2
    },
    isMultiCars() {
      return this.vx_billInfo.cars > 1 || this.vx_billInfo.result === 2
    },
    driverName() {
      return Object.keys(this.vx_driverInfo).length
        ? `${this.vx_driverInfo.teamName}-${this.vx_driverInfo.name}`
        : ''
    },
    driverPhone() {
      return Object.keys(this.vx_driverInfo).length
        ? this.vx_driverInfo.driverPhone
        : ''
    },
    driverCallNumber() {
      return Object.keys(this.vx_driverInfo).length
        ? this.vx_driverInfo.driverCallNumber
        : ''
    },
    clerkName() {
      if (this.vx_billInfo.callMethod === 1) {
        return this.vx_serviceInfo.name
      }
      if (this.vx_billInfo.callMethod === 2) {
        return this.vx_managerInfo.name
      }
      return 'Line、APP叫車'
    },
    isDisabled() {
      /* 若無司機接單的狀，則disabled司機取消的btn */
      return !this.vx_billInfo.result
    },
  },
  created() {
    this.unwatchPassengerNote = this.$store.watch(
      (state) => state.reservation.modal.billInfo.passengerNote,
      (newVal) => {
        this.passengerNote = newVal
      },
    )
  },
  beforeDestroy() {
    this.unwatchPassengerNote()
  },
}
</script>

<style lang="scss" scoped>
.btn-tooltip {
  position: relative;
}

.tooltip-text {
  visibility: hidden;
  position: absolute;
  width: 10rem;
  bottom: 110%;
  left: 50%;
  margin-left: -5rem; /* 讓tooltip置中，delta_x = (width=10rem) / 2 = 5rem */
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  z-index: 1;
}

/* tooltip底部加上小箭頭 */
.tooltip-text::after {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.btn-tooltip:hover {
  .tooltip-text {
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reservation/components/Bottom.vue